import { getAccessToken, parseAccessTokenClaims, switchAuthContext } from '@beatq/shared';
import { resolveBusinessAccountId, setStoredBusinessAccountId } from './businessContext.js';

function getApiBaseUrl(): string {
  if (typeof import.meta !== 'undefined') {
    const env = (import.meta as { env?: { VITE_API_BASE_URL?: string } }).env;
    if (env?.VITE_API_BASE_URL) return env.VITE_API_BASE_URL;
  }
  return '';
}

/** Ensure JWT carries `bac` for /business/v1 scoped APIs. */
export async function ensureBusinessAccountContext(): Promise<string> {
  const token = getAccessToken();
  if (!token) throw new Error('Authentication required');

  const claims = parseAccessTokenClaims(token);
  const existingBac = claims.bac ?? null;
  if (existingBac) {
    setStoredBusinessAccountId(existingBac);
    return existingBac;
  }

  const businessAccountId = resolveBusinessAccountId(null);
  if (!businessAccountId) {
    throw new Error(
      'No business account is linked to this session. Sign in with a corporate account, then try again.',
    );
  }
  await switchAuthContext(getApiBaseUrl(), 'business', { businessAccountId });
  setStoredBusinessAccountId(businessAccountId);
  return businessAccountId;
}
